import { render, staticRenderFns } from "./SafetyCheckCurrentStatusPhoto.vue?vue&type=template&id=2cc7d888&scoped=true&"
import script from "./SafetyCheckCurrentStatusPhoto.vue?vue&type=script&lang=js&"
export * from "./SafetyCheckCurrentStatusPhoto.vue?vue&type=script&lang=js&"
import style0 from "./SafetyCheckCurrentStatusPhoto.vue?vue&type=style&index=0&id=2cc7d888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc7d888",
  null
  
)

export default component.exports